<div style="height: 400px">
  <ag-charts [options]="chartOptions"></ag-charts>
</div>
